module.exports = __webpack_public_path__ + "img/atlas-logo.e89b29f7.png";